import React from 'react';
import { useDispatch } from 'react-redux';
import { fetchAccountFilters } from '../../../actions/parent/accountConfigurations/fetch';
import AccountFiltersPage from '../../../components/body/parentSettings/configurations/AccountFiltersPage';

const AccountFiltersContainer: React.FC = () => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(fetchAccountFilters({ page: 1 }));
  }, [dispatch]);

  return <AccountFiltersPage />;
};

export default AccountFiltersContainer;
